<template>
  <li class="mega-menu__menu-item mega-menu__menu-item--depth-1">
    <template v-if="itemIsDefined(item, 'childMenu')">
      <button class="mega-menu__link mega-menu__button mega-menu__link--depth-1" @click="toggleNextDepth">
        {{ item.label }}
        <chevron-right />
      </button>
      <ul class="mega-menu mega-menu--depth-2"
        :class="nextDepthOpen ? 'mega-menu--depth--show' : ''">
        <button class="mega-menu__title" @click="backOneLevel">
          <chevron-right />
          {{ item.label}}
          </button>
        <a v-if="itemIsDefined(item, 'link.title')" 
          :href="getLink(item.link)" 
          class="mega-menu__link mega-menu__link--depth-2">{{ item.link.title }}</a>
        <mobile-menu-level-2 v-for="(itemDepth1, index) in item.childMenu"
          :key="`mobile-2-${index}`"
          :itemDepth1="itemDepth1"
          @backOneLevel="backOneLevel" />
      <div class="mega-menu__menu-highlights">
        <div class="mega-menu__menu-highlights-item" v-for="highlightedItem in item.image">
          <a v-if="itemIsDefined(highlightedItem, 'image.file.mobileUrl')"
            :href="getLink(highlightedItem.link)">
            <img class="highlight-img" :src="highlightedItem.image.file.mobileUrl">
          </a>
          <a v-if="itemIsDefined(highlightedItem, 'link.title')" 
            :href="getLink(highlightedItem.link)">
            <h4 class="highlight-title">{{ highlightedItem.link.title }}</h4>
          </a>
        </div>
      </div>
    </ul>
    </template>
    <a v-else-if="itemIsDefined(item, 'link.title')" 
      :href="getLink(item.link)" 
      class="mega-menu__link mega-menu__link--depth-1">{{ item.link.title }}</a>
  </li>
</template>

<script>
import MobileMenuLevel2 from '@/components/layout/header/MobileMenu/MobileMenuLevel2'
import ChevronRight from "@/components/layout/header/icons/ChevronRight"
import mainSite from "@/util/mainSite"

export default {
	components: {
    MobileMenuLevel2,
    ChevronRight
  },
  mixins: [mainSite],
  data() {
    return {
      nextDepthOpen: false
    }
  },
  props: {
    item: {
      type: Object,
      required: true,
      default: {}
    },
  },
  methods: {
    toggleNextDepth() {
      this.nextDepthOpen = !this.nextDepthOpen
    },
    backOneLevel() {
      this.nextDepthOpen = false;
    }
  },
}
</script>